import { render, staticRenderFns } from "./ContactPersonActions.vue?vue&type=template&id=219c15c8&"
import script from "./ContactPersonActions.vue?vue&type=script&lang=js&"
export * from "./ContactPersonActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports